import { LINKEDIN_PIXEL_TRACKING_ID } from "./gvSecrets";

const debugMode = false;

const isLocalhost =
  window.location?.hostname?.includes("localhost") || window.location?.hostname?.includes("127.0.0.1");

export const trackLinkedinPixelEvent = () => {
  if (isLocalhost && !debugMode) {
    return;
  }

  try {
    window.lintrk("track", { conversion_id: LINKEDIN_PIXEL_TRACKING_ID });
  } catch {
    // do nothing
  }
};
